import type { UITranslations } from './types';

export const en: UITranslations = {
    common: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this item?',
        view: 'View',
        edit: 'Edit',
        duplicate: 'Duplicate',
        refresh: 'Refresh',
        noData: 'No data',
        actions: 'Actions',
        showing: '{{from}}-{{to}} of {{total}} items',
        filters: 'Filters',
        resetFilters: 'Reset filters',
        noFiltersAvailable: 'No filters available',
        resetToDefault: 'Reset to default',
        showColumns: 'Columns',
        search: 'Search',
        changeFile: 'Change file',
        removeFile: 'Remove',
        noPermissionTooltip: 'You do not have permission to perform this action',
        copy: 'Copy',
        copied: 'Copied',
        all: 'All',
        startDate: 'Start date',
        endDate: 'End date',
        columns: 'Columns',
        retry: 'Retry',
        errorTitle: 'Something went wrong',
    },
    upload: {
        fileTooLarge: 'File is too large',
        invalidFormat: 'Unsupported file format',
        uploadError: 'Upload failed',
        uploaded: 'Uploaded successfully',
        uploading: 'Uploading...',
        uploadHint: 'Click or drag a file to this area to upload',
        stagingHint: 'Click to select a reference file',
        uploadFormats: 'Supported formats only',
        previewAlt: 'Preview',
        changeImage: 'Change image',
        remove: 'Remove',
    },
    password: {
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
    },
    pageHeader: {
        aboutThisPage: 'About this page',
    },
    collapsible: {
        expand: 'Expand',
        collapse: 'Collapse',
    },
};
